import React, { useState } from "react";
import { ProjectsListLogic } from "../ProjectsListLogic";
import { Link, useNavigate } from "react-router-dom";
import { branding } from "../../config";

export function ProjectsListPublic(props) {

    return (
        <ProjectsListLogic
            {...props}
            render={({projects}) => (
                <div style={{ maxWidth: "900px", margin: "0 auto" }}>
                    {projects.map((project, i) => (
                        <div
                            key={i}
                            className="project-row"
                            style={{
                                display: "flex",
                                flexDirection: i % 2 === 0 ? "row" : "row-reverse",
                                alignItems: "flex-start",
                                marginBottom: "60px",
                                gap: "30px",
                                flexWrap: "nowrap", // ✅ prevent stacking
                            }}
                        >
                            <img
                                src={project.image}
                                alt={project.name}
                                loading={i < 2 ? "eager" : "lazy"}
                                style={{
                                    width: "300px",
                                    height: "auto",
                                    borderRadius: "8px",
                                    flexShrink: 0,
                                }}
                            />
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <h3 style={{ color: branding.primaryColor, fontWeight: "600", marginBottom: "10px", fontSize: "2rem" }}>
                                    {project.name}
                                </h3>
                                <p style={{ lineHeight: "1.6", color: "#333", fontSize: "1.15rem" }}>{project.description}</p>
                                {project.link && (
                                    <Link className="small-link" to={project.link} style={{fontSize: "1.5rem"}}>
                                        {project.link_label ? project.link_label : "Learn More"} →
                                    </Link>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        />
    );
}